import { createGlobalStyle } from 'styled-components';
import { AntDesignOverrides } from './antDesignOverrides';

type Props = {
  isDark: boolean;
};

const GlobalStyles = createGlobalStyle<Props>`
	:root {
		font-family: fontSans, sans-serif;
		font: var(--font-m);

		color-scheme: light;
		color: var(--secondary-color);

		font-synthesis: none;
		text-rendering: optimizeLegibility;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		-webkit-text-size-adjust: 100%;
		user-select: text !important;
		-webkit-user-select: text !important;
		-moz-user-select: text !important;
		-ms-user-select: text !important;
	}

	.zero-padding-dropdown {
		.ant-dropdown-menu-item {
			padding: 0 !important;
		}
	}

	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
		font-family: fontSans, sans-serif;
		user-select: text !important;
		-webkit-user-select: text !important;
		-moz-user-select: text !important;
		-ms-user-select: text !important;
	}

	* ::-webkit-scrollbar {
		width: 5px;
		height: 5px;
	}

	* ::-webkit-scrollbar-track {
		background: transparent;
	}

	* ::-webkit-scrollbar-thumb {
		background: #c2c2c2;
		border-radius: 5px;
	}

	* ::-webkit-scrollbar-thumb:hover {
		background: #555555;
	}

	textarea,
	select,
	input,
	button {
		background: none;
		border: none;
		outline: none;
		margin: 0;
		font: inherit;
		user-select: text !important;
		-webkit-user-select: text !important;
		-moz-user-select: text !important;
		-ms-user-select: text !important;
	}

	body {
		min-height: 100dvh;
		max-width: calc(100vw);
		font-family: fontSans, sans-serif;
	}


	a {
		text-decoration: none;
		color: var(--link-color);
		transition: var(--timing-s);

		&:hover {
			color: var(--link-hover-color)
		}

		&:active {
			color: var(--link-color);
		}
	}

	.ant-layout-has-sider {
		background-color: var(--bg-dark-color) !important;
	}

	* {

		.ant-menu-submenu-popup {
			display: none;
		}
	}

	::selection {
		color: var(--secondary-inverted-color);
		background: var(--primary-color);
	}

	/* Enable text selection for inputs and textareas */
	input,
	textarea,
	.ant-input,
	.ant-input-number,
	.ant-input-textarea,
	.ant-modal,
	.ant-modal-content {
		user-select: text !important;
		-webkit-user-select: text !important;
		-moz-user-select: text !important;
		-ms-user-select: text !important;
	}

	:root {
		--font-family-primary: fontSans, sans-serif;

		--font-size-xs: 0.6rem;
		--font-line-height-xs: 1.2rem;
		--font-xs: var(--font-size-xs) / var(--font-line-height-xs) var(--font-family-primary);

		--font-size-s: 0.8rem;
		--font-line-height-s: 1.4rem;
		--font-s: var(--font-size-s) / var(--font-line-height-s) var(--font-family-primary);

		--font-size-m: 1rem;
		--font-line-height-m: 1.6rem;
		--font-m: var(--font-size-m) / var(--font-line-height-m) var(--font-family-primary);

		--font-size-l: 1.2rem;
		--font-line-height-l: 1.8rem;
		--font-l: var(--font-size-l) / var(--font-line-height-l) var(--font-family-primary);

		--font-size-xl: 1.8rem;
		--font-line-height-xl: 2.4rem;
		--font-xl: var(--font-size-xl) / var(--font-line-height-xl) var(--font-family-primary);

		--font-size-xxl: 2rem;
		--font-line-height-xxl: 2.6rem;
		--font-xxl: var(--font-size-xxl) / var(--font-line-height-xxl) var(--font-family-primary);

		--font-size-xxxl: 3.5rem;
		--font-line-height-xxxl: 4.1rem;
		--font-xxxl: var(--font-size-xxxl) / var(--font-line-height-xxxl) var(--font-family-primary);

		--spacing-xxs: 0.1rem;
		--spacing-xs: 0.4rem;
		--spacing-s: 0.8rem;
		--spacing-m: 1.2rem;
		--spacing-l: 1.6rem;
		--spacing-xl: 2.5rem;
		--spacing-xxl: 3.2rem;

		--border-radius-xs: 2px;
		--border-radius-s: 4px;
		--border-radius-m: 8px;
		--border-radius-l: 20px;
		--border-radius-xl: 40px;

		--timing-xs: 0.06s;
		--timing-s: 0.1s;
		--timing-m: 0.25s;
		--timing-l: 0.6s;
		--timing-xl: 1s;
		--timing-xxl: 3s;

		--sider-z-index: 100;
		--nav-bar-z-index: 10;
		--search-textarea-z-index: 10;

		--nav-bar-height: 58px;

		--blur-s: blur(3px);
		--blur-m: blur(5px);
		--blur-l: blur(10px);
	}

	${AntDesignOverrides}

	/* Nuclear option: force text selection on EVERYTHING in app */
	html, body, body * {
		user-select: text !important;
		-webkit-user-select: text !important;
		-moz-user-select: text !important;
		-ms-user-select: text !important;
	}

	/* Specific overrides for all common elements */
	p, span, div, a, li, td, th, tr, label, h1, h2, h3, h4, h5, h6 {
		user-select: text !important;
		-webkit-user-select: text !important;
		-moz-user-select: text !important;
		-ms-user-select: text !important;
	}
`;

export { GlobalStyles };
